import React, { useEffect, useState } from "react";
import { Button, DatePicker, Divider, Spin, Result } from "antd";
import GridLayout from "./GridLayout";
import { Navbar } from "../Navigation/Navbar";
import AddNewDialog from "./AddNewDialog";
import { TrainingAPI } from "../../api/TrainingAPI";
import JsPDF from "jspdf";
import html2canvas from "html2canvas";
import { ReloadOutlined } from "@ant-design/icons";
import { IoRefreshOutline } from "react-icons/io5";
import { audioMessage as message } from "../Common/Notifications/audioMessage";

import moment from "moment";
import { v1 as uuidv1 } from "uuid";

const Dashboard = () => {
  let trainingAPI = new TrainingAPI();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().subtract(14, "days").format("YYYY-MM-DD")
  );
  const [metricOptions, setMetricOptions] = useState();
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [dashItems, setDashItems] = useState([]);
  const [layouts, setLayouts] = useState({});
  const [gotDash, setGotDash] = useState(false);

  const [playerMetrics, setPlayerMetrics] = useState([]);
  const [drillList, setDrillList] = useState([]);

  const [loading, setLoading] = useState(false);

  const handleLayoutChange = (layout, layouts) => {
    layouts.lg = adjust_layout_minimums(layout);
    layouts.md = adjust_layout_minimums(layout);
    layouts.sm = adjust_layout_minimums(layout);
    layouts.xs = adjust_layout_minimums(layout);
    layouts.xxs = adjust_layout_minimums(layout);
    setLayouts(layouts);
  };

  const adjust_layout_minimums = (layout) => {
    // [minW, minH]
    let minimums = {
      datatable: [5, 4],
      logo: [1, 2],
      tile: [2, 3],
      text: [2, 1],
      chart: [2, 4],
      combochart: [2, 4],
    };

    layout = layout.map((layout_item) => {
      let item_type = dashItems.find(
        (dash_item) => layout_item.i == dash_item.id
      ).config.title;
      if (layout_item.w == 1 && layout_item.h == 1) {
        let mins = minimums[item_type] || [2, 3];
        return {
          ...layout_item,
          w: Math.max(layout_item.w, mins[0]),
          h: Math.max(layout_item.h, mins[1]),
        };
      } else {
        return layout_item;
      }
    });

    return layout;
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const generatePDF = () => {
    let element = document.getElementById("gridLayout");

    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const pdf = new JsPDF("landscape", "px", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgProps = pdf.getImageProperties(imgData);
      const imgWidth = pdfWidth;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
      let yOffset = 0;
      let remainingHeight = imgHeight;

      while (remainingHeight > 0) {
        pdf.addImage(imgData, "PNG", 0, yOffset * -1, imgWidth, 0);
        remainingHeight -= pdfHeight;
        yOffset += pdfHeight;
        if (remainingHeight > 0) {
          pdf.addPage();
        }
      }
      pdf.save("download.pdf");
    });
  };

  //   useEffect(() => {
  //     window.addEventListener('error', e => {
  //         if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
  //             const resizeObserverErrDiv = document.getElementById(
  //                 'webpack-dev-server-client-overlay-div'
  //             );
  //             const resizeObserverErr = document.getElementById(
  //                 'webpack-dev-server-client-overlay'
  //             );
  //             if (resizeObserverErr) {
  //                 resizeObserverErr.setAttribute('style', 'display: none');
  //             }
  //             if (resizeObserverErrDiv) {
  //                 resizeObserverErrDiv.setAttribute('style', 'display: none');
  //             }
  //         }
  //     });
  // }, []);

  const onDateChange = (value, dateString) => {
    setStartDate(dateString[0] === "" ? null : dateString[0]);
    setEndDate(dateString[1] === "" ? null : dateString[1]);
    //getDashBoard();
  };

  const getDashBoard = () => {
    // console.log("get dash");
    // setLoading(true);

    // const dashboardPromise = trainingAPI
    //   .getDashboard(startDate, endDate)
    //   .then((data) => {
    //     console.log("resp", data);
    //     data?.dashItems && setDashItems(data.dashItems);
    //     data?.layouts && setLayouts(data.layouts);
    //   });

    // const playerMetricsPromise = trainingAPI
    //   .getPlayerMetrics(startDate, endDate)
    //   .then((data) => setPlayerMetrics(data));

    // const teamMetricsPromise = trainingAPI
    //   .getTeamMetrics()
    //   .then((data) => setMetricOptions(data));

    // const drillsPromise = isAuthenticated ? trainingAPI
    //   .getDrills()
    //   .then((data) => setDrillList(data));

    // // Wait for all promises to resolve
    // Promise.all([
    //   dashboardPromise,
    //   playerMetricsPromise,
    //   teamMetricsPromise,
    //   drillsPromise,
    // ])
    //   .then(() => {
    //     // All promises are resolved, so setLoading can be set to false
    //     setLoading(false);
    //   })
    //   .catch((e) => {
    //     console.log("An error occurred:", e);
    //     setLoading(false); // Set loading to false even in case of error
    //   });
  };

  if (!gotDash) {
    getDashBoard();
    setGotDash(true);
  }

  const onSaveDashBoard = () => {
    let dash_configs = [];
    dashItems.forEach((item) =>
      dash_configs.push({ config: item.config, id: item.id })
    );
    trainingAPI
      .saveDashboard(layouts, dash_configs)
      .then((res) => console.log(JSON.parse(res)))
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    if (dashItems?.length > 0 && layouts?.lg?.length > 0) {
      console.log("save dash");
      onSaveDashBoard();
    }
  }, [layouts]);

  const onSubmitDialog = async (data) => {
    console.log("submit", data);

    trainingAPI
      .getDashboardTileData(data, startDate, endDate)
      .then((res) =>
        setDashItems([
          ...dashItems,
          { config: data, response: res, id: uuidv1() },
        ])
      )
      .catch((e) => console.log(e));

    setIsModalOpen(false);
  };

  const { RangePicker } = DatePicker;

  // useEffect(() => {
  //   console.log("set dash", dashItems);
  //   authAPI
  //     .logged_in()
  //     .then(async (data) => {
  //       const teamMetrics = await trainingAPI.getTeamMetrics();
  //       console.log("teamMetrics", teamMetrics);
  //       setMetricOptions(teamMetrics);
  //     })
  //     .catch((data) => {
  //       // setLoggedIn(false);
  //     });
  // }, [dashItems]);

  const onClickSave = () => {
    onSaveDashBoard();
    message.success("Saved!");
  };

  return (
    <div style={{ background: "#f5f5f5", height: "100%" }}>
      <Navbar />

      <Result
  status="500"
  title="Looks like something's wrong here."
  subTitle="Please be patient while we fix this."
  style={{height: '100vh'}}
/>

      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "10px",
          alignItems: "center",
          columnGap: "1em",
        }}
      >
        {loading && <Spin style={{ margin: "1em" }} />}
        <RangePicker
          onChange={onDateChange}
          value={[moment(startDate), moment(endDate)]}
        />

        <Button icon={<IoRefreshOutline />} onClick={() => getDashBoard()} />
        <Button onClick={showModal}>Add</Button>
        <Button onClick={generatePDF}>Export PDF</Button>
        <Button onClick={onClickSave}>Save</Button>
      </div>
      <AddNewDialog
        open={isModalOpen}
        onSubmit={onSubmitDialog}
        onCancel={handleCancel}
        playerMetrics={playerMetrics}
        drillList={drillList}
      />

      <div id="gridLayout">
        <GridLayout
          layouts={layouts}
          handleLayoutChange={handleLayoutChange}
          dashItems={dashItems}
          setDashItems={setDashItems}
          metricOptions={metricOptions}
          playerMetrics={playerMetrics}
          drillList={drillList}
          startDate={startDate}
          endDate={endDate}
        />
      </div> */}
    </div>
  );
};
export default Dashboard;
